import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "@/pages/HowItWorks";

const IMG = "https://images.unsplash.com/photo-1609377375732-7abb74e435d9?crop=entropy&cs=srgb&fm=jpg&q=85";

const BENEFITS = [
  "Get matched with a partner who shares your sport and goals",
  "Build streaks and stay consistent week after week",
  "Schedule activities and check in at partner facilities",
  "Track your progress and celebrate your milestones",
  "Earn rewards as consistency becomes second nature",
];

export default function ForMembers() {
  return (
    <div data-testid="for-members-page">
      <PageHero eyebrow="For Members" title="Never Train Alone Again" subtitle="I want an accountability partner to help me stay consistent." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative rounded-2xl overflow-hidden border border-zinc-800 order-2 lg:order-1">
            <img src={IMG} alt="Member training" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
          </div>
          <div className="order-1 lg:order-2">
            <h2 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight">Accountability that actually works</h2>
            <p className="mt-4 text-zinc-400 leading-relaxed">Motivation fades — systems don't. FitLynk pairs you with someone who keeps you showing up, so your goals stop being wishful and start being weekly.</p>
            <ul className="mt-8 space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="grid place-items-center w-6 h-6 rounded-full bg-[#E53E3E]/15 text-[#E53E3E] mt-0.5 shrink-0"><Check className="w-4 h-4" /></span>
                  <span className="text-zinc-300">{b}</span>
                </li>
              ))}
            </ul>
            <Link to="/get-started">
              <Button size="lg" className="mt-9 bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-14 px-8">Register as a Member <ArrowRight className="w-5 h-5 ml-2" /></Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
